// extracted by mini-css-extract-plugin
module.exports = {"page":"page__3Np1c","page-body":"page-body__19g1M"};